import jsPDF from 'jspdf';
import 'jspdf-autotable'

declare module 'jspdf' {
    interface jsPDF {
      autoTable: any; // Override type checking for autoTable
    }
  }
  
export const downloadPDF = (testtext:Array<any>, docname?:string) => {
    const pdf = new jsPDF();
    // pdf.text(testtext, 10, 10);
    pdf.autoTable({ body: [[testtext]], didDrawCell: (data:any) => {
        data.cell.styles = { valign: 'top', halign: 'justify' }; // Set text alignment to justify
      }, });
    pdf.save(`${docname ? docname : 'Document'}.pdf`);
  };